import { AfterViewInit,Component, Inject, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { BaseComponent } from '@eview/core';
import { GetChartsData, GetRegionData } from '@eview/core/store/actions/dashboard.actions';
import { selectForms } from '@eview/core/store/selectors/forms.selector';
import { selectChartsData, selectRegionData } from '@eview/core/store/selectors/dashboard.selector';
import { AppState } from '@eview/core/store/states/app.state';
import { NgbDateParserFormatter,NgbDate,NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { map, shareReplay } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterHelpers } from '@eview/core/domain/filters/filters.helper';
import * as moment from 'moment';
import { selectTenant } from '@eview/core/store/selectors/tenant.selector';
import { Permission } from '@eview/core/auth/permission';
import { AuthHelpers } from '@eview/core/auth';
import { Subscription ,Observable, combineLatest } from 'rxjs';
import { environment } from '@eview/core/environments/environment';
import { sortFormsDefaultFirst } from '@eview/core/domain/form/form';
import { SearchableSelectOption } from '@eview/features/ui/searchable-select/searchable-select.component';

@Component({
  selector: 'eview-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.scss']
})
export class DashboardComponent extends BaseComponent
  implements OnInit, OnDestroy, AfterViewInit{

  radioSelect = 'all';
  currentLang: string;
  model: NgbDateStruct;
  date: { year: number; month: number } = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };
  fromdate: Date = null;
  todate: Date = null;
  formType: String = 'all';
  formTypeChart: String = 'all';
  minDate = { year: new Date().getFullYear() - 100, month: 1, day: 1 };
  maxDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };
  reportTypeDisabled: boolean = true;
  applyButtonDisabled: boolean = true;
  tenantName:string;
  labels : string[];
  labelName:string;
  formList$ : Observable<any>;
  formTypePieChart: String | null = null;
  $selectRegionData: any;
  tenant$: Observable<any>;
  regionData$: Observable<any>;
  womenCount$: Observable<any>;
  minoritiesCount$: Observable<any>;
  LGTBIQCount$: Observable<any>;
  reportsCount$: Observable<any>;
  pieChartData$: Observable<any>;
  pieChartDataWomen$: Observable<any>;
  pieChartDataMinorities$: Observable<any>;
  pieChartDataLGTBIQGroups$: Observable<any>;
  monthlyRecords$: Observable<any>;
  dailyRecords$: Observable<any>;
  getSelectedFilterDate$: Observable<any>;


  // Colores predefinidos para mejor rendimiento
  private readonly CHART_COLORS = [
    '#007ee7', '#00c49f', '#ffbb28', '#ff8042', '#8884d8',
    '#82ca9d', '#ffc658', '#8dd1e1', '#d084d0', '#a4de6c',
    '#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#6c5ce7'
  ];

  private getChartColor(index: number): string {
    return this.CHART_COLORS[index % this.CHART_COLORS.length];
  }

  constructor(protected store: Store<AppState>, private translate: TranslateService, @Inject(ViewContainerRef) private viewContainerRef: ViewContainerRef,
    private modalService: NgbModal,
  ) {
    super();
    this.currentLang =
      this.translate.currentLang || this.translate.getDefaultLang() || 'es';

    this.tenant$ = this.store.select(selectTenant);
    this.regionData$ = this.store.select(selectRegionData);
    this.womenCount$ = this.store.select(selectRegionData).pipe(
      map(data =>
        data.pie_chart['women'] ? data.pie_chart['women']['total_affected_count'] : 0
      )
    );
    this.minoritiesCount$ = this.store.select(selectRegionData).pipe(
      map(data =>
        data.pie_chart['minorities'] ? data.pie_chart['minorities']['total_affected_count'] : 0
      )
    );
    this.LGTBIQCount$ = this.store.select(selectRegionData).pipe(
      map(data =>
        data.pie_chart['LGTBIQ'] ? data.pie_chart['LGTBIQ']['total_affected_count'] : 0
      )
    );
    this.reportsCount$ = this.store.select(selectRegionData).pipe(
      map(data => (data ? data.total_posts : 0))
    );
    this.pieChartData$ = this.store.select(selectRegionData).pipe(
      map(data => {
        if (data && typeof data.regions !== 'undefined') {
          const regions = data.regions;
          const labels = Object.keys(regions).map(key => key || 'BLANK');
          const labelColors = labels.map((_, i) => this.getChartColor(i));
          return {
            data: {
              labels: labels,
              datasets: [{
                label: '',
                data: Object.values(regions),
                backgroundColor: labelColors,
                hoverOffset: 4
              }]
            }
          };
        }
        return null;
      }),
      shareReplay(1)
    );
    this.pieChartDataWomen$ = this.store
      .select(selectRegionData)
      .pipe(
      map(data => {
        if (data && data.pie_chart && data.pie_chart['women']) {
          const womenData = data.pie_chart['women'];

          if (womenData && 'total_affected_count' in womenData) {
            const filteredData = {
              si: womenData.yes,
              no: womenData.no
            };

            const labels = Object.keys(filteredData);
            const labelColors = labels.map((_, i) => this.getChartColor(i));

            return {
              data: {
                labels: labels,
                datasets: [{
                  label: '',
                  data: Object.values(filteredData),
                  backgroundColor: labelColors,
                  hoverOffset: 4
                }]
              }
            };
          }
        }
        return null;
      }),
      shareReplay(1)
    );

    this.pieChartDataMinorities$ = this.store
      .select(selectRegionData)
      .pipe(
        map(data => {
          if (data && data.pie_chart && data.pie_chart['minorities']) {
            const MinoritiesData = data.pie_chart['minorities'];

            if (MinoritiesData && 'total_affected_count' in MinoritiesData) {
              const filteredData = {
                si: MinoritiesData.yes,
                no: MinoritiesData.no
              };

              const labels = Object.keys(filteredData);
              const labelColors = labels.map((_, i) => this.getChartColor(i));

              return {
                data: {
                  labels: labels,
                  datasets: [{
                    label: '',
                    data: Object.values(filteredData),
                    backgroundColor: labelColors,
                    hoverOffset: 4
                  }]
                }
              };
            }
          }
          return null;
        }),
        shareReplay(1)
      );

    this.pieChartDataLGTBIQGroups$ = this.store
      .select(selectRegionData)
      .pipe(
      map(data => {
        if (data && data.pie_chart && data.pie_chart['LGTBIQ']) {
          const LGTBIQData = data.pie_chart['LGTBIQ'];

          if (LGTBIQData && 'total_affected_count' in LGTBIQData) {
            const filteredData = {
              si: LGTBIQData.yes,
              no: LGTBIQData.no
            };

            const labels = Object.keys(filteredData);
            const labelColors = labels.map((_, i) => this.getChartColor(i));

            return {
              data: {
                labels: labels,
                datasets: [{
                  label: '',
                  data: Object.values(filteredData),
                  backgroundColor: labelColors,
                  hoverOffset: 4
                }]
              }
            };
          }
        }
        return null;
      }),
      shareReplay(1)
    );

    this.monthlyRecords$ = this.store.select(selectChartsData).pipe(
      map(data => {
        if (data) {
          return {
            data: {
              datasets: [{
                label: this.labelName,
                data: Object.values(data.monthly_records),
                backgroundColor: 'rgb(115 185 243 / 65%)',
                borderColor: '#007ee7',
                fill: true,
              }],
              labels: this.labels
            },
            options: {
              responsive: true,
              scales: {
                xAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: data.year
                  }
                }],
                yAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: this.labelName
                  }
                }]
              }
            }
          };
        }
        return undefined;
      })
    );

    this.dailyRecords$ = this.store.select(selectChartsData).pipe(
      map(data => {
        if (data) {
          return {
            data: {
              datasets: [{
                label: this.labelName,
                data: Object.values(data.daily_records),
                backgroundColor: 'rgb(115 185 243 / 65%)',
                borderColor: '#007ee7',
                fill: true,
              }],
              labels: Object.keys(data.daily_records)
            },
            options: {
              responsive: true,
              scales: {
                xAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: moment().month(data.month).subtract(1, 'month').format('MMMM') + ' ' + data.year
                  }
                }],
                yAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: this.labelName
                  }
                }]
              }
            }
          };
        }
        return undefined;
      })
    );

    this.getSelectedFilterDate$ = this.store.select(selectChartsData).pipe(
      map(data => {
        if (data) {
          return {
            month: moment().month(data.month).subtract(1, 'month').format('MMMM'),
            year: data.year
          };
        }
        return {
          month: moment().format('MMMM'),
          year: moment().format('YYYY')
        };
      })
    );
  }

  ngOnInit() {
    // Optimizar verificaciones de permisos - ejecutar en paralelo
    this.formList$ = combineLatest([
      this.store.select(selectForms),
      AuthHelpers.User.AccessibleFormIds(this.store, 'analysis')
    ]).pipe(
      map(([forms, allowedIds]) => {
        const all = allowedIds === null;
        const allow = new Set(allowedIds || []);
        return sortFormsDefaultFirst(
          forms.results
            .filter(form => {
              if (form.disabled) return false;
              return all || allow.has(form.id);
            })
        ).map(form => ({
            ...form,
            form_name: this.currentLang === 'am' ? form.name_am : form.name
          }));
      }),
      shareReplay(1)
    );

    this.tenant$.subscribe(tenant => {
      this.tenantName = tenant.unique_name;
      if (this.tenantName == 'madagascar') {
        this.labels = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'];
        this.labelName = "Nombre de rapports";
      } else if (this.tenantName == 'peru') {
        this.labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        this.labelName = "Number of reports";
      } else {
        this.labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        this.labelName = "Number of reports";
      }

      this.onRadioChange();
      this.getChartsData();
    });
  }

  ngAfterViewInit() {
    // Code to hide the calendar panel should be placed here
    const calendarPanel = document.querySelector('.date-filter .ngb-dp-month');
    if (calendarPanel) {
      calendarPanel.setAttribute('style', 'display: none !important;');
    }
  }

  ngOnDestroy() {
  }

  pieChartFormSelectOptions(
    formList: { id: number; name: string }[]
  ): SearchableSelectOption[] {
    const pleaseSelect = this.translate.instant('PLEASE_SELECT');
    return [
      { value: null, label: pleaseSelect },
      ...(formList || []).map(f => ({ value: f.id, label: f.name }))
    ];
  }

  chartFormSelectOptions(
    formList: { id: number; name: string }[]
  ): SearchableSelectOption[] {
    return [
      {
        value: 'all',
        label: this.translate.instant('POST_STATUS_ALL')
      },
      ...(formList || []).map(f => ({ value: f.id, label: f.name }))
    ];
  }

  onRadioChange() {
 if (this.radioSelect === 'all') {
    let formTypeName:string = 'all';
     this.formList$.subscribe(list => {
        if(list.length == 1 ) {
           formTypeName = list[0].id;
        }
      })
      if(formTypeName == 'all') {
        this.formTypePieChart = 'all'
        this.store.dispatch(new GetRegionData());
      }else {
        this.formTypePieChart = formTypeName;
         const payload = {
            formId: formTypeName
          }
          this.store.dispatch(new GetRegionData( payload));
      }

    }
    else {
      this.formType=  'all';
      this.fromdate = null;
      this.todate = null;
      this.reportTypeDisabled = false;
    }
  }

  onApplyClick() {

    var ngbObjToDate =  JSON.parse(JSON.stringify(this.todate));
    var toDate = moment();

    var ngbObjFromDate =  JSON.parse(JSON.stringify(this.fromdate));
    var fromDate = moment();

    if (ngbObjToDate) {
      ngbObjToDate.month--;
      toDate.month(ngbObjToDate.month);
      toDate.dates(ngbObjToDate.day);
      toDate.year(ngbObjToDate.year);
    }

    if (ngbObjFromDate) {
      ngbObjFromDate.month--;
      fromDate.month(ngbObjFromDate.month);
      fromDate.dates(ngbObjFromDate.day);
      fromDate.year(ngbObjFromDate.year);
    }

    const payload = {
      formId: this.formTypePieChart ,
      to_date: toDate.format('YYYY-MM-DD'),
      from_date: fromDate.format('YYYY-MM-DD'),
      att_1: environment.pieChart.att_1,
      att_2: environment.pieChart.att_2,
      att_3: environment.pieChart.att_3
    };
    payload.formId  = this.formTypePieChart;
    this.store.dispatch(new GetRegionData(payload));
    this.reportTypeDisabled = true;
    this.applyButtonDisabled = true;
  }

  getChartsData() {
    const payload = {
      formId: this.formTypeChart,
      date_month: this.date.month,
      date_year: this.date.year
    }
    if(this.formTypeChart == 'all') {
      let formTypeName:string = 'all';
      this.formList$.subscribe(list => {
         if(list.length == 1 ) {
            formTypeName = list[0].id;
         }
       })
       if(formTypeName === 'all') {
         payload.formId === 'all' ? delete payload['formId'] : null;
       }else {
        payload.formId = formTypeName;
       }
    }else {
      payload.formId === 'all' ? delete payload['formId'] : null;
    }
    this.store.dispatch(new GetChartsData(payload));
  }

  onFilterChange() {
    if (this.formTypeChart && this.fromdate && this.todate) {
      this.reportTypeDisabled = false;
      this.applyButtonDisabled = false;
    }
  }
}
